import axios from 'axios';

export const LEGAL_METADATA_URL = 'https://cdn-web.yimian.com.cn/assets/metadata/legal.json';

const isNonEmptyString = value => typeof value === 'string' && value.trim().length > 0;

export const isChineseLocale = locale => typeof locale === 'string' && /^zh(?:-|_|$)/i.test(locale);

export function splitChineseLegalText(text) {
  const parts = /^(.*[|｜]\s*)([^|｜]+)$/.exec(text)
    || /^(.*?)(粤?ICP备[^\s]+)$/i.exec(text);
  if (!parts) {
    return { prefix: text, icp: '' };
  }

  return {
    prefix: parts[1],
    icp: parts[2].trim(),
  };
}

export function parseLegalFooter(payload, currentYear = new Date().getFullYear()) {
  const footer = payload && payload.default && payload.default.footer;
  if (!footer || !isNonEmptyString(footer.zh) || !isNonEmptyString(footer.en)
    || !isNonEmptyString(footer.icpLink) || !/^https?:\/\//i.test(footer.icpLink.trim())) {
    return null;
  }

  const zh = footer.zh.replace(/\{current\}/g, String(currentYear));
  if (!isNonEmptyString(splitChineseLegalText(zh).icp)) {
    return null;
  }

  return {
    zh,
    en: footer.en.replace(/\{current\}/g, String(currentYear)),
    icpLink: footer.icpLink.trim(),
  };
}

export function loadLegalFooter(http = axios, currentYear = new Date().getFullYear()) {
  return http.get(LEGAL_METADATA_URL)
    .then((response) => {
      if (response && typeof response.status === 'number'
        && (response.status < 200 || response.status >= 300)) {
        return null;
      }
      return parseLegalFooter(response && response.data, currentYear);
    })
    .catch(() => null);
}



// WEBPACK FOOTER //
// ./src/utils/legal-footer.js